const stripBase64Prefix = (image) => {
  if (!image) return image;
  return image
    .replace("data:image/png;base64,", "")
    .replace("data:image/jpeg;base64,", "")
    .replace("data:image/jpg;base64,", "")
    .replace("data:image/svg+xml;base64,", "");
};

export const hydrateBasicInfoForm = (customerData) => ({
  customerNumber: customerData?.customerNumber ?? "",
  customerName: customerData?.customerName ?? "",
  streetAddress: customerData?.address?.addressLine1 ?? "",
  city: customerData?.address?.city ?? "",
  state: customerData?.address?.state ?? "",
  postalCode: customerData?.address?.zipCode ?? "",
  phone: customerData?.phone ?? "",
  country: customerData?.address?.country ?? "US",
  domain: Array.isArray(customerData?.settings?.domain) && customerData.settings.domain.length ? customerData.settings.domain : [""],
  accountGroup: customerData?.accountGroup ?? "",
  salesOfficeDescription: customerData?.salesOfficeDescription ?? "",
  customerGroup: customerData?.customerGroup ?? "",
  woundCareSalesRepName: customerData?.woundCareSalesRepName ?? "",
  divisionManagerName: customerData?.divisionManagerName ?? "",
});

const cleanDomains = (domain) => (Array.isArray(domain) ? domain : []).map((entry) => (entry || "").trim()).filter(Boolean);

export const buildBasicInfoPayload = ({ form, customerData, header }) => {
  const finalPic = stripBase64Prefix(header?.companyLogo);

  return {
    ...customerData,
    customerName: form.customerName,
    phone: form.phone,
    customerGroup: form.customerGroup,
    accountGroup: form.accountGroup || customerData?.accountGroup,
    salesOfficeDescription: form.salesOfficeDescription,
    divisionManagerName: form.divisionManagerName,
    woundCareSalesRepName: form.woundCareSalesRepName,
    statusInfo: customerData?.statusInfo,
    address: {
      ...customerData?.address,
      addressLine1: form.streetAddress,
      city: form.city,
      state: form.state || null,
      country: form.country,
      zipCode: form.postalCode,
    },
    settings: {
      ...customerData?.settings,
      customerStatus: header?.customerStatus,
      companyLogo: finalPic,
      domain: cleanDomains(form.domain),
      sessionTimeout: header?.sessionTimeout,
      sessionTimeoutType: header?.sessionTimeoutType,
    },
  };
};
